import { AddProps, convertProps, IFormItemProps, MyModal } from "@/Common/Form/MyModal";
import { getOptions } from "@/Models/Enums/BillTypeCategory";
import { BillType } from "@/Models/Tables/BillType";
import { Form, Input, Select } from "antd";
import { useMemo } from "react";
import { useCallback } from "react";

function Item(props: IFormItemProps<BillType>) {
    return <Form.Item {...convertProps(props)}  ></Form.Item>;
}

function Add({ onCancel, onSubmit, data }: AddProps<BillType>) {
    const [form] = Form.useForm();
    const onOk = useCallback(() => {
        form.validateFields().then(onSubmit);
    }, [form, onSubmit]);
    const options = useMemo(getOptions, []);
    return <MyModal name="单据类别" data={data} width={360} onCancel={onCancel} onOk={onOk}>
        <Form form={form} labelAlign="right" initialValues={data} labelCol={{ span: 8 }}>

            <Item name="category" label="单据类别"  >
                <Select disabled={data !== undefined} options={options} optionFilterProp="label" showSearch allowClear  ></Select>
            </Item>

            <Item name="name" label="单据名称" required >
                <Input ></Input>
            </Item>
            <Item name="code" label="编码" required >
                <Input ></Input>
            </Item>
            <Item name="remark" label="备注" >
                <Input ></Input>
            </Item>
        </Form>
    </MyModal>;
}

export default Add;